import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const EXP = () => {
  return (
    <CardSection id="EXP" title="EXP">
      <Paragraph>지정된 값의 지수를 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>EXP(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>EXP(`Column`)</Paragraph>
        <Img src="computeExp" />
      </ListSection>
    </CardSection>
  );
};
